import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
export function CountdownSection() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 23,
    minutes: 58,
    seconds: 33
  });
  const [mounted, setMounted] = useState(false);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    setMounted(true);
    const savedEndTime = localStorage.getItem('megapack_countdown_end');
    let endTime: number;
    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10);
      if (endTime < Date.now()) {
        endTime = Date.now() + 24 * 60 * 60 * 1000;
        localStorage.setItem('megapack_countdown_end', endTime.toString());
      }
    } else {
      endTime = Date.now() + 23 * 60 * 60 * 1000 + 58 * 60 * 1000 + 33 * 1000;
      localStorage.setItem('megapack_countdown_end', endTime.toString());
    }
    const calculateTimeLeft = () => {
      const difference = endTime - Date.now();
      if (difference > 0) {
        setTimeLeft({
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      } else {
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
      }
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <section className="text-white py-24 px-4 relative overflow-hidden border-t border-[#FF1E00]/10" style={{
    background: 'linear-gradient(180deg, #2A0E0E 0%, #1A0808 40%, #110505 100%)'
  }} data-id="element-35">
      {/* Subtle warm radial glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-[#3D1111]/40 rounded-full blur-[150px] pointer-events-none" data-id="element-36"></div>

      {/* Subtle background dot pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }} data-id="element-37"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-38">
        <motion.h2 className="text-3xl md:text-5xl font-heading font-bold mb-12 md:mb-16 uppercase tracking-wide" initial={{
        opacity: 0,
        y: -20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-39">
          ⏰ EL PRECIO DE
          <br className="md:hidden" data-id="element-40" /> LANZAMIENTO TERMINA EN:
        </motion.h2>

        {mounted && <motion.div className="flex justify-center items-start gap-2 md:gap-6 mb-16 md:mb-24" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-41">
            {/* Hours */}
            <div className="flex flex-col items-center" data-id="element-42">
              <span className="text-7xl sm:text-8xl md:text-[140px] leading-none font-heading font-black text-[#FF1E00] tracking-tighter" data-id="element-43">
                {formatNumber(timeLeft.hours)}
              </span>
              <span className="text-sm md:text-xl uppercase tracking-[0.2em] text-white/60 mt-4 font-bold" data-id="element-44">
                HS
              </span>
            </div>

            <span className="text-6xl sm:text-7xl md:text-[120px] leading-none font-bold text-[#FF1E00] mt-1 md:mt-2" data-id="element-45">
              :
            </span>

            {/* Minutes */}
            <div className="flex flex-col items-center" data-id="element-46">
              <span className="text-7xl sm:text-8xl md:text-[140px] leading-none font-heading font-black text-[#FF1E00] tracking-tighter" data-id="element-47">
                {formatNumber(timeLeft.minutes)}
              </span>
              <span className="text-sm md:text-xl uppercase tracking-[0.2em] text-white/60 mt-4 font-bold" data-id="element-48">
                MIN
              </span>
            </div>

            <span className="text-6xl sm:text-7xl md:text-[120px] leading-none font-bold text-[#FF1E00] mt-1 md:mt-2" data-id="element-49">
              :
            </span>

            {/* Seconds */}
            <div className="flex flex-col items-center" data-id="element-50">
              <span className="text-7xl sm:text-8xl md:text-[140px] leading-none font-heading font-black text-[#FF1E00] tracking-tighter" data-id="element-51">
                {formatNumber(timeLeft.seconds)}
              </span>
              <span className="text-sm md:text-xl uppercase tracking-[0.2em] text-white/60 mt-4 font-bold" data-id="element-52">
                SEG
              </span>
            </div>
          </motion.div>}

        <motion.p className="text-2xl md:text-4xl font-bold mb-20 md:mb-28" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-53">
          Después sube <span className="text-[#FF1E00]" data-id="element-54">$10.000 ARS</span> y no
          vuelve a bajar.
        </motion.p>

        <motion.div className="max-w-3xl mx-auto w-full mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-55">
          <div className="flex justify-between items-end mb-4 px-1" data-id="element-56">
            <div className="flex items-center gap-3" data-id="element-57">
              {/* 3D-looking red circle */}
              <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-[#FF1E00] shadow-[inset_-2px_-2px_4px_rgba(0,0,0,0.4),0_0_10px_rgba(255,30,0,0.5)]" data-id="element-58"></div>
              <span className="text-[#FF1E00] font-bold text-lg md:text-2xl tracking-tight" data-id="element-59">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-white font-bold text-lg md:text-2xl tracking-tight" data-id="element-60">
              Quedan pocos
            </span>
          </div>

          {/* Progress Bar */}
          <div className="w-full h-5 md:h-6 bg-[#2A3441] rounded-full overflow-hidden mb-3" data-id="element-61">
            <motion.div className="h-full rounded-full bg-gradient-to-r from-[#FF1E00] to-[#FF6B00]" initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut',
            delay: 0.2
          }} data-id="element-62" />
          </div>

          <div className="text-right text-white/50 text-sm md:text-base font-medium" data-id="element-63">
            68% de los cupos tomados
          </div>
        </motion.div>

        <motion.button onClick={scrollToPricing} className="w-full max-w-3xl mx-auto bg-brand-accent text-brand-dark hover:bg-brand-accent-dim font-heading font-black text-2xl md:text-3xl py-6 md:py-8 px-8 rounded-2xl transition-all flex items-center justify-center gap-3" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} animate={{
        boxShadow: ['0px 0px 0px rgba(0,255,133,0)', '0px 0px 40px rgba(0,255,133,0.4)', '0px 0px 0px rgba(0,255,133,0)']
      }} transition={{
        boxShadow: {
          repeat: Infinity,
          duration: 2
        }
      }} data-id="element-64">
          → ASEGURAR MI PRECIO AHORA
        </motion.button>
      </div>
    </section>;
}